// Register enums and select options

export const RegisterType = Object.freeze({
  General: 1,
  Equipment: 2,
  Pipeline: 3,
  Structural: 4,
  Inspection: 5,
  Anomaly: 6,
  AvaInspect: 7,
  Scaffold: 8,
  Permit: 9,
  Container: 10,
  Operation: 11,
});

export const RegisterStatus = Object.freeze({
  Active: 1,
  Draft: 2,
  Inactive: 3,
});

export const RegisterTypeOptions = [
  { text: 'Equipment', value: RegisterType.Equipment },
  { text: 'Pipeline', value: RegisterType.Pipeline },
  { text: 'Structural', value: RegisterType.Structural },
  { text: 'Inspection', value: RegisterType.Inspection },
  { text: 'General', value: RegisterType.General },
  { text: 'Anomaly', value: RegisterType.Anomaly },
  { text: 'AVA Inspection', value: RegisterType.AvaInspect },
  { text: 'Scaffold', value: RegisterType.Scaffold },
  { text: 'Permit', value: RegisterType.Permit },
  { text: 'Container', value: RegisterType.Container },
  { text: 'Operation', value: RegisterType.Operation },
];

export const RegisterStatusOptions = [
  { text: 'Active', value: RegisterStatus.Active },
  { text: 'Draft', value: RegisterStatus.Draft },
  { text: 'Inactive', value: RegisterStatus.Inactive },
];

export function getRegisterTypeText(value) {
  const found = RegisterTypeOptions.find((o) => o.value === value);
  return found ? found.text : '';
}

export function getRegisterStatusText(value) {
  const found = RegisterStatusOptions.find((o) => o.value === value);
  return found ? found.text : '';
}

// Export enums for register data export functionality
export const ExportFormat = Object.freeze({
  Csv: 1,
  Xlsx: 2,
});

export const ExportMode = Object.freeze({
  Filtered: 1, // Uses column filters (empty filters = all rows)
  Selected: 2, // Uses specific row IDs
});

export const ExportFormatOptions = [
  { text: 'Excel (.xlsx)', value: ExportFormat.Xlsx },
  { text: 'CSV (.csv)', value: ExportFormat.Csv },
];

export const ExportModeOptions = [
  { text: 'Export Filtered Data', value: ExportMode.Filtered },
  { text: 'Export Selected Rows', value: ExportMode.Selected },
];

export function getExportFormatText(value) {
  const found = ExportFormatOptions.find((o) => o.value === value);
  return found ? found.text : '';
}

export function getExportModeText(value) {
  const found = ExportModeOptions.find((o) => o.value === value);
  return found ? found.text : '';
}
